import {
    ISearch,
    ISearchProfile,
    ISearchProvider,
    HorizAlignment,
    SearchProviderFieldType,
    ISearchProviderField,
    ISearchRequestSubset
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import { PASearch } from "../PA.Core/PASearch"
import { SearchUtils } from "../PA.UIM.Core/SearchUtils"
import { PAEnvironment } from "../PA.Core/PAEnvironment"

const vUI_FundingAccount_Search_Fields: { [id: string]: ISearchProviderField } = {
    WB_FUNDINGACCOUNT_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: "Funding Account WB Id",
            columnResourceName: "colId",
            alignment: HorizAlignment.Center
        },
        domainOptions: {}
    },
    FUNDINGACCOUNT_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: "ID", columnResourceName: "colId", alignment: HorizAlignment.Right },
        domainOptions: { maxLength: 50 }
    },
    FUNDINGACCOUNT_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: "Name", columnResourceName: "colName", alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 256 }
    },
    FUNDINGACCOUNT_TYPE: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: "Type", columnResourceName: "colTypeName", alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 256 }
    },
    WB_MDSET_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: "Master Dataset WB Id",
            columnResourceName: "colWbMDsetId",
            alignment: HorizAlignment.Center
        },
        domainOptions: {}
    },
    MDSET_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: "MDSet ID", columnResourceName: "colMDSetId", alignment: HorizAlignment.Right },
        domainOptions: { maxLength: 50 }
    },
    MDSET_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: "MDSet", columnResourceName: "colMDSetName", alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 256 }
    },
    WB_SALESORG_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: "Sales Org WB Id",
            columnResourceName: "colWbSalesOrgId",
            alignment: HorizAlignment.Center
        },
        domainOptions: {}
    },
    SALESORG_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: "Sales Org ID",
            columnResourceName: "colSalesOrgId",
            alignment: HorizAlignment.Right
        },
        domainOptions: { maxLength: 50 }
    },
    SALESORG_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: "Sales Org",
            columnResourceName: "colSalesOrgName",
            alignment: HorizAlignment.Left
        },
        domainOptions: { maxLength: 256 }
    },
    WB_CUST_ID_FINDING: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: "Customer WB Id",
            columnResourceName: "colwbCustId",
            alignment: HorizAlignment.Center
        },
        domainOptions: {}
    },
    CUSTOMER_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: "Customer ID", columnResourceName: "colCustId", alignment: HorizAlignment.Right },
        domainOptions: { maxLength: 50 }
    },
    CUSTOMER_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: "Customer", columnResourceName: "colCustName", alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 256 }
    },
    WB_USRGRP_ID_FUNDING: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: "User Group WB Id",
            columnResourceName: "colwbUsrGrpId",
            alignment: HorizAlignment.Center
        },
        domainOptions: {}
    },
    USRGRP_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: "User Group ID",
            columnResourceName: "colUsrGrpId",
            alignment: HorizAlignment.Right
        },
        domainOptions: { maxLength: 50 }
    },
    USRGRP_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: "User Group",
            columnResourceName: "colUsrGrpName",
            alignment: HorizAlignment.Left
        },
        domainOptions: { maxLength: 256 }
    },
    WB_PRDGRP_ID_FUNDING: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: "Product Group WB Id",
            columnResourceName: "colWbPrdGrpId",
            alignment: HorizAlignment.Center
        },
        domainOptions: {}
    },
    PRODUCT_GROUP_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: "Product Group ID",
            columnResourceName: "colPrdGrpId",
            alignment: HorizAlignment.Right
        },
        domainOptions: { maxLength: 50 }
    },
    PRODUCT_GROUP_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: "Product Group",
            columnResourceName: "colPrdGrpName",
            alignment: HorizAlignment.Left
        },
        domainOptions: { maxLength: 256 }
    },
    WB_PLAN_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: "Plan WB Id",
            columnResourceName: "colwbPlanId",
            alignment: HorizAlignment.Center
        },
        domainOptions: {}
    },
    PLAN_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: "Plan ID", columnResourceName: "colPlanId", alignment: HorizAlignment.Right },
        domainOptions: { maxLength: 50 }
    },
    PLAN_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: "Plan", columnResourceName: "colPlanName", alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 256 }
    },
    WB_PRDGRP_ID_PLANLEVEL: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: "Planning Level WB Id",
            columnResourceName: "colwbLevelId",
            alignment: HorizAlignment.Center
        },
        domainOptions: {}
    },
    PLANNING_LEVEL_ID:{
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: "Planning Level Id",
            columnResourceName: "colLevelId",
            alignment: HorizAlignment.Center
        },
        domainOptions: {}
    },
    WB_PERIOD_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: "Period WB Id",
            columnResourceName: "colwbPeriodId",
            alignment: HorizAlignment.Center
        },
        domainOptions: {}
    },
    PERIOD_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: "Period ID", columnResourceName: "colPeriodId", alignment: HorizAlignment.Right },
        domainOptions: { maxLength: 50 }
    },
    PERIOD_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: "Period", columnResourceName: "colPeriodName", alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 256 }
    }
}

const FundingAccountSearchProviderBasic: ISearchProvider = {

    keyFields: {
        id: "WB_FUNDINGACCOUNT_ID",
        id_ui: "FUNDINGACCOUNT_ID",
        name: "FUNDINGACCOUNT_NAME"
    },


    searchProviderFields: vUI_FundingAccount_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                "vUI_FundingAccount_Search",
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

}


const FundingAccountSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "FundingAccountSearchProfileByName" },

    profileFilter: [
        { profileFilterName: "Id", searchProviderFieldId: "FUNDINGACCOUNT_ID", renderOptions: {} },
        { profileFilterName: "Name", searchProviderFieldId: "FUNDINGACCOUNT_NAME", renderOptions: {} },
        { profileFilterName: "CustName", searchProviderFieldId: "CUSTOMER_NAME", renderOptions: {} },
        { profileFilterName: "PrdGrpName", searchProviderFieldId: "PRODUCT_GROUP_NAME", renderOptions: {} },
        { profileFilterName: "UsrGrpName", searchProviderFieldId: "USRGRP_NAME", renderOptions: {} },
        { profileFilterName: "PlanName", searchProviderFieldId: "PLAN_NAME", renderOptions: {} },
        { profileFilterName: "MdSetName", searchProviderFieldId: "MDSET_NAME", renderOptions: {} },
        { profileFilterName: "SalesOrgName", searchProviderFieldId: "SALESORG_NAME", renderOptions: {} }

    ],  // ISearchFields
    profileDisplayFields: [
        "FUNDINGACCOUNT_ID", "FUNDINGACCOUNT_NAME", "FUNDINGACCOUNT_TYPE", "CUSTOMER_NAME", "PRODUCT_GROUP_NAME", "PLAN_NAME", "PERIOD_NAME", "USRGRP_NAME", "MDSET_NAME", "SALESORG_NAME"
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: FundingAccountSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}

const FundingAccountSearch: ISearch = {
    searchName: "Find Funding Account",
    renderOptions: { ui5ResourceId: "FundingAccountSearch" },
    searchProfileIdDefault: "default",
    searchProfiles: [FundingAccountSearchProfileByName]
}

//PAEnvironment.registerBusinessObjectSearch("FundingAccountBO", "Funding Account", FundingAccountSearch, "Funding Account Search")

export { FundingAccountSearch }